import script from "./QuickAddLicenseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAddLicenseDialog.vue?vue&type=script&setup=true&lang=js"

import "./QuickAddLicenseDialog.vue?vue&type=style&index=0&id=3bd78e2b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd78e2b"]])

export default __exports__